<template>
  <div class="production">
    <drug-guide title="产品中心" :headimg="proHead" :enimg="enImg"></drug-guide>
    <div class="pro-tab">
      <div class="pro-tablist">
        <div :class="tabidx == index ? 'pro-tabitem on' : 'pro-tabitem'" v-for="(item, index) in tabList" :key="index" @click="getTab(index)">{{ item.name }}</div>
      </div>
    </div>
    <div class="pro-good">
      <div class="pro-goodlist" v-for="(item, index) in goodList" :key="index" @click="getDetail(item.id)">
        <div class="goodlist-img">
          <img class="goodlist-bg" :src="goodBg" alt="">
          <div class="goodlist-type">{{ item.cate_name }}</div>
          <img class="goodlist-thumb" :src="item.thumb" alt="">
        </div>
        <div class="goodlist-con">
          <div class="goodlist-title">{{ item.title }}</div>
          <div class="goodlist-desc">{{ item.bref }}</div>
          <div class="goodlist-more">查看更多</div>
        </div>
      </div>
      <el-pagination class="workpage" background layout="prev, pager, next" :total="total" :page-size="9"  prev-text="上一页" next-text="下一页" @current-change="currentChange"></el-pagination>
    </div>
    <drug-footer></drug-footer>
  </div>
</template>

<script>
import DrugFooter from "../../components/DrugFooter";
import DrugGuide from "../../components/DrugGuide";
import { getCate, getList } from "@/api/index";
export default {
  name: "Production",
  components: {
    DrugFooter,
    DrugGuide
  },
  data() {
    return {
      proHead: "static/images/production/pro-head.png",
      enImg: "static/images/production/pro-en.png",
      goodBg: "static/images/production/pro-goodbg.png",
      tabidx: 0,
      tabList: [
        {
          name: "全部产品",
          id: 0
        }
      ],
      goodList: [],
      page: 1,
      total: 0
    }
  },
  computed: {
    pid: {
      get () {
        return this.$store.state.pid;
      }
    },
  },
  watch: {
    '$store.state.keyword'(val) {
      var activeVal = this.$store.state.activeVal;
      if(activeVal == 2) {
        getList(this.pid, this.tabList[this.tabidx].id, this.page, val).then((res) => {
          if(res.data.code == 1) {
            this.goodList = res.data.data.rows;
            this.total = res.data.data.total;
          }
        })
      }
    }
  },
  created() {
    this.getGoodList(null);
  },
  methods: {
    // 分页
    currentChange(index) {
      this.page = index;
      this.getGoodList(this.tabList[this.tabidx].id);
    },
    getTab(index) {
      this.tabidx = index;
      this.page = 1;
      this.getGoodList(this.tabList[index].id);
    },
    getDetail(id) {
      this.$router.push({
        path: "/production/detail",
        query: { id }
      })
    },
    getCateList() {
      var id = this.pid ? this.pid : 1;
      getCate(id).then((res) => {
        this.tabList = [
          {
            name: "全部产品",
            id: null,
            pid: this.pid
          }
        ];
        if(res.data.code == 1) {
          var list = res.data.data;
          for(let i in list) {
            this.tabList.push(list[i]);
          }
        }
      })
    },

    // 获取列表数据
    getGoodList(cateId) {
      getList(this.pid ? this.pid : 1, cateId, this.page, "").then((res) => {
        if(res.data.code == 1) {
          this.goodList = res.data.data.rows;
          this.total = res.data.data.total;
        }
      })
    }
  },
  mounted() {
    this.$store.commit("getactive", 2);
    this.getCateList();
  }
}
</script>

<style lang="scss" scoped>
.production {
  .pro-tab {
    width: 100%;
    height: 50px;
    background: #fff;
    .pro-tablist {
      width: 80%;
      height: 100%;
      margin: auto;
      display: flex;
      align-items: center;
      cursor: pointer;
      .pro-tabitem {
        height: 100%;
        line-height: 50px;
        padding: 0 14px;
        color: #7C828A;
        &.on {
          color: #fff;
          background: #092C52;
          font-family: "PingFang SC-Medium", "PingFang SC";
        }
      }
    }
  }
  .pro-good {
    width: 80%;
    height: auto;
    overflow: hidden;
    margin: auto;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    // justify-content: space-between;
    .pro-goodlist {
      width: 32%;
      margin-top: 30px;
      margin-right: 2%;
      cursor: pointer;
      .goodlist-img {
        width: 100%;
        height: 252px;
        position: relative;
        .goodlist-bg {
          width: 100%;
          height: 100%;
          display: block;
        }
        .goodlist-type {
          position: absolute;
          top: 0;
          left: 0;
          height: 32px;
          line-height: 32px;
          padding: 0 10px;
          border-radius: 0 10px 0 0;
          background: linear-gradient(270deg, #B1FAFF 0%, #4392EC 100%);
          z-index: 20;
          color: #fff;
        }
        .goodlist-thumb {
          position: absolute;
          z-index: 10;
          bottom: 0;
          top: 0;
          left: 0;
          right: 0;
          margin: auto;
          height: 200px;
          display: block;
        }
      }
      .goodlist-con {
        padding: 0 34px;
        height: 178px;
        background: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .goodlist-title {
          font-size: 18px;
          font-family: "PingFang SC-Medium", "PingFang SC";
          font-weight: 500;
          color: #002244;
          height: 25px;
          line-height: 25px;
        }
        .goodlist-desc {
          text-align: center;
          font-weight: 400;
          color: #7C828A;
          line-height: 24px;
          margin-bottom: 16px;
          height: 70px;
          overflow: hidden;
          text-overflow: ellipsis;

        }
        .goodlist-more {
          width: 120px;
          text-align: center;
          height: 40px;
          line-height: 40px;
          font-weight: 400;
          color: #7C828A;
          border: 1px solid #DDDDDD;
        }
      }
    }
    .pro-goodlist:nth-of-type(3n+3) {
      margin-right: 0;
    }
    .workpage {
      width: 90%;
      margin: 40px auto;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

// 分页器样式
.production /deep/ .el-pagination.is-background {
  color: #909090;
  font-weight: 400;
}
.production /deep/ .el-pagination.is-background .el-pager li {
  width: 38px;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  margin: 0 5px;
  font-size: 16px;
}
// 上一页/下一页
.production /deep/ .el-pagination.is-background button {
  height: 40px;
  padding: 0 10px;
}
.production /deep/ .el-pagination.is-background button span {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/production/production.vue